export var SimpleFormIteratorPrefix = 'RaSimpleFormIterator';
export var SimpleFormIteratorClasses = {
    action: "".concat(SimpleFormIteratorPrefix, "-action"),
    add: "".concat(SimpleFormIteratorPrefix, "-add"),
    clear: "".concat(SimpleFormIteratorPrefix, "-clear"),
    form: "".concat(SimpleFormIteratorPrefix, "-form"),
    index: "".concat(SimpleFormIteratorPrefix, "-index"),
    inline: "".concat(SimpleFormIteratorPrefix, "-inline"),
    line: "".concat(SimpleFormIteratorPrefix, "-line"),
    list: "".concat(SimpleFormIteratorPrefix, "-list"),
    buttons: "".concat(SimpleFormIteratorPrefix, "-buttons"),
};
//# sourceMappingURL=useSimpleFormIteratorStyles.js.map